module.exports = __webpack_public_path__ + "media/images/wedding/thumb/24-a4de972d358dc47064e17fe3fe1e7105.jpg";